import { IOmniaHttpService, IOmniaSession } from "../../types"
import { defineDirective } from "../../utils/angular"

const emailRegex = /^[\w._%+-]+@[\w.-]+\.[A-Za-z]{2,}$/

/** @internal */
export class ResetPwdCtrl1 {

    sending = false

    static create(): ng.IDirective {

        return defineDirective(ResetPwdCtrl1, "shared/main/resetpwd/reset1.html");

    }

    sent = false

    static $inject = ["OmniaSession", "OmniaHttpService"]

    constructor(
        private session: IOmniaSession,
        private ohttp: IOmniaHttpService,
        public email = session.loginLinkUser ?? session.shouldResetPassword?.email) {
    }

    canCommit() {
        const { email, sent, sending } = this
        return (!sending) && (!sent) && email && emailRegex.test(email)
    }

    commit() {
        const { email } = this
        this.sending = true
        const url = `/api/user/v1/password/reset?email=${encodeURIComponent(email)}`
        this.ohttp
            .post(url).then(r => {
                this.sent = true
            })
            .finally(() => this.sending = false)
    }

    cancel() {
        this.session.setResetPassword(false, undefined)
    }

}

